import React from 'react';
import FRcameraProvider from './useAiCamera';
import FRfaceDetection from './Components/FaceDetection/FRdetection';
import FRmatcher from './Components/FaceMatcher/FRmatcher';
import FRregistration from './Components/FaceRegistration/FRfaceRegistration';
import FRbiometric from './Components/FaceBiometric/FRbiometric';

const FaceRecognitionCamera = params => {
  const { mode } = params?.data || params?.settings || {};

  return (
    <FRcameraProvider params={params}>
      {mode === 1 && <FRregistration {...params} />}
      {mode === 2 && <FRfaceDetection {...params} />}
      {mode === 3 && <FRmatcher {...params} />}
      {mode === 4 && <FRbiometric {...params} />}
    </FRcameraProvider>
  );
};

export default FaceRecognitionCamera;
